/**
 * Human-readable message for a failed derin API call.
 *
 * The backend wraps errors as `{ status: "error", message }`, and its interceptor puts the
 * useful text in `message` — including translated ones such as the missing Survey API admin
 * key. Falls back through the other shapes an axios failure can take so a toast never ends
 * up empty.
 */
export const errorMessageOf = (err: any): string =>
  err?.response?.data?.message ||
  err?.response?.data?.error ||
  err?.message ||
  "Unknown error";
